/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { EMPTY_ARRAY } from 'constants/frozenObjects'
import FormField from 'apps/FormField'
import Loading from 'apps/Loading'
import SelectComponent, { SelectItem } from 'elements/Select'
import { isErrorShown, getMessageText, getFieldState } from 'utils/field'

const Select: React.FC<any> = ({
  input,
  meta,
  options = EMPTY_ARRAY,
  labelRenderer,
  t,
  label,
  apiTypes,
  required,
  ...restProps
}) => (
  <FormField
    isErrorShown={isErrorShown(meta)}
    errorMessage={getMessageText(meta, t)}
    label={label}
    required={required}
  >
    <Loading apiTypes={apiTypes} loading={!!apiTypes}>
      <SelectComponent
        {...input}
        {...restProps}
        labelRenderer={labelRenderer}
        options={options}
        state={getFieldState(meta)}
      >
        {options.map(({ label, value, ...restProps }) => {
          const currentLabel = labelRenderer ? labelRenderer({ label, value, ...restProps, isMenu: true }) : label
          return <SelectItem key={value} value={value}>{currentLabel}</SelectItem>
        })}
      </SelectComponent>
    </Loading>
  </FormField>
)

export default Select
